import makeService from './api';

export default makeService('categorie_partenaires');
